export enum ImportWalletCsvResponseStatusCodes {
  InvalidFormat = 415,
}
